import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useSpendSummary(start: string, end: string) {
  return useQuery({
    queryKey: ["spend", "summary", start, end],
    queryFn: () => api.getSpendSummary(start, end),
    enabled: !!start && !!end,
  });
}

export function useSpendTrend(params: { days?: number; start?: string; end?: string }) {
  return useQuery({
    queryKey: ["spend", "trend", params],
    queryFn: () =>
      api.getSpendTrend({
        days: params.days ? String(params.days) : undefined,
        start: params.start,
        end: params.end,
      }),
  });
}

export function useDailySpend(date: string) {
  return useQuery({
    queryKey: ["spend", "daily", date],
    queryFn: () => api.getDailySpend(date),
    enabled: !!date,
  });
}

export function useBackfill() {
  return useMutation({
    mutationFn: ({ start, end }: { start: string; end: string }) => api.triggerBackfill(start, end),
  });
}
